import React from 'react'
import { Html, Button, Head, Font, Hr, Img } from "@react-email/components";

function Contact() {
    const Font = () => {
        return (
            <Html lang="en">
                <Head>
                    <Font
                        fontFamily="Roboto"
                        fallbackFontFamily="Verdana"
                        webFont={{
                            url: "https://fonts.gstatic.com/s/roboto/v27/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2",
                            format: "woff2",
                        }}
                        fontWeight={400}
                        fontStyle="normal"
                    />
                </Head>
            </Html>
        );
    };
    const Image = () => {
        return <Img src="cat.jpg" alt="Cat" width="300" height="300" />;
    };
    const Email = () => {

        return (
            <Head>
                <title>My email title</title>
            </Head>
        );
    };

    return (
        <Html lang="en" dir="ltr">
            <Button href="https://example.com" style={{ color: "#61dafb" }}>
                Click me

            </Button>
        </Html>
    )
}

export default Contact